import { ReactComponent as DataUsageIcon } from './data-usage.svg';

export default DataUsageIcon;
